import styled from 'styled-components';

import { Checkbox } from '@savgroup-front-common/core/atoms/checkbox';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $AgreementText = styled.span`
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  margin-right: ${spacing('sm')};
`;

export const StyledLink = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.mainTextColor};
`;
